/* ============================================================
   galeria-cor-simples.js

   Escolhida uma cor, a galeria mostra so a capa e a foto dessa
   cor. Sem isto o cliente que escolhe preto continua a folhear
   fotos vermelhas e verdes, e ve a mesma mala repetida.

   POR QUE E QUE NAO ADIVINHA A COR DAS OUTRAS FOTOS:
   tentou-se medir a cor dominante de cada foto e associa-la a
   variante mais parecida. Falha: os modelos usam calcas escuras
   e as fotos de pe mostram pele, o que puxa a medida para o
   castanho — no sapato Karolina o grupo do castanho ficou com
   um sapato preto e um bege dentro. Tentou-se depois deduzir
   pela ordem das fotos: so 13 dos 709 produtos tem as fotos em
   blocos por cor. Nao ha sinal fiavel.

   Por isso este ficheiro usa apenas o que a loja garante: cada
   variante tem a sua foto (featured_media), que vem do proprio
   produto e nunca esta errada. Se a variante nao tiver foto, ou
   nao houver JSON, nao esconde nada — falhar mostrando fotos a
   mais e sempre melhor do que esconder a foto certa.
   ============================================================ */
(function () {
  'use strict';

  var CLASSE = 'escondida-por-cor';

  function json() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function idDaMedia(el) {
    var v = el.getAttribute('data-media-id') || '';
    var n = parseInt(v.split('-').pop(), 10);
    return isNaN(n) ? null : n;
  }

  function varianteAtual(dados) {
    var id = new URLSearchParams(location.search).get('variant');
    if (id) {
      for (var i = 0; i < dados.variants.length; i++) {
        if (String(dados.variants[i].id) === String(id)) return dados.variants[i];
      }
    }
    return null;
  }

  function aplicar(dados) {
    var v = varianteAtual(dados);
    var slides = document.querySelectorAll('.product__slide[data-media-id]');
    var thumbs = document.querySelectorAll('[data-thumb-item]');
    if (!slides.length) return;

    // sem cor escolhida, ou variante sem foto: mostra tudo
    var alvo = v && v.featured_media ? v.featured_media.id : null;

    function trata(lista) {
      for (var i = 0; i < lista.length; i++) {
        var el = lista[i];
        var mid = idDaMedia(el) || idDaMedia(el.querySelector('[data-media-id]') || el);
        var manter = !alvo || i === 0 || mid === alvo;
        el.classList.toggle(CLASSE, !manter);
      }
    }
    trata(slides);
    trata(thumbs);
  }

  function arranca() {
    var dados = json();
    if (!dados || !dados.variants || !dados.variants.length) return;
    if (!document.querySelector('.product__slides')) return;

    var correr = function () { aplicar(dados); };
    correr();

    // a escolha da cor troca o ?variant= no endereco; o tema faz isso
    // por replaceState, que nao dispara evento nenhum, por isso
    // observa-se a galeria em vez de esperar por um evento.
    var alvo = document.querySelector('.product__slides');
    new MutationObserver(correr).observe(alvo, {
      attributes: true, subtree: true, attributeFilter: ['class']
    });
    document.addEventListener('change', correr);
    window.addEventListener('popstate', correr);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();
